import { Button, Grid } from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import TaskIcon from "@mui/icons-material/Task";
import CreditCardOffIcon from "@mui/icons-material/CreditCardOff";
import SchoolIcon from "@mui/icons-material/School";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import ContentPasteOffIcon from "@mui/icons-material/ContentPasteOff";
import React, { useContext } from "react";
import "../../../styles/Layout/Admin_Styles/_DownloadData.scss";
import { authHttp } from "../../services/utility";
import { apisPath } from "../../../utils/path";
import { AuthContext } from "../../../context/AuthContext";

const cards = [
  {
    title: "Completed Application Data",
    icon: <TaskIcon className="download-icon-custom" />,
    btns: [
      {
        title: "Download",
        apiKey: "CompletedData",
        path: apisPath?.admin?.downloadCandidateData,
      },
    ],
  },
  {
    title: "Incomplete Application Data",
    icon: <CreditCardOffIcon className="download-icon-custom" />,
    btns: [
      {
        title: "Download",
        apiKey: "IncompletedData",
        path: apisPath?.admin?.downloadCandidateData,
      },
    ],
  },
  // {
  //   title: "Education Paid Data",
  //   icon: <SchoolIcon className="download-icon-custom" />,
  //   apiKey: ''
  // },
  // {
  //   title: "Education Not Paid Data",
  //   icon: <RemoveCircleIcon className="download-icon-custom" />,
  //   apiKey: ''
  // },
  {
    title: "Cancelled Application Data",
    icon: <ContentPasteOffIcon className="download-icon-custom" />,
    btns: [
      {
        title: "Download",
        apiKey: "CancelledData",
        path: apisPath?.admin?.downloadCandidateData,
      },
    ],
  },
  {
    title: "Education Completed Data",
    icon: <SchoolIcon className="download-icon-custom" />,
    btns: [
      {
        title: "Download",
        apiKey: "educationPaidData",
        path: apisPath?.admin?.downloadEducationData,
      },
      {
        title: "Download (Row Wise)",
        apiKey: "educationPaidData",
        path: apisPath?.admin?.downloadEducationDataRowWise,
      },
    ],
  },
  {
    title: "Education Incomplete Data",
    icon: <RemoveCircleIcon className="download-icon-custom" />,
    btns: [
      {
        title: "Download",
        apiKey: "educationNotPaidData",
        path: apisPath?.admin?.downloadEducationData,
      },
      {
        title: "Download (Row Wise)",
        apiKey: "educationNotPaidData",
        path: apisPath?.admin?.downloadEducationDataRowWise,
      },
    ],
  },
];

function DownloadData() {
  return (
    <div className="download-data">
      <div className="download-data--header">
        <h2>Download Data</h2>
      </div>
      <div className="download-data--card">
        <Grid container spacing={2} rowSpacing={4}>
          {cards.map((card) => (
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
              <DownloadDataCard
                icon={card?.icon}
                title={card?.title}
                btns={card?.btns}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}

function DownloadDataCard(_props) {
  const { title, icon, btns } = _props;
  const { setIsLoading, setAlertState } = useContext(AuthContext);

  const downloadExcel = (key, path) => {
    setIsLoading(true);
    // console.log(url)
    authHttp
      .post(path, { download_request: key })
      .then((res) => {
        // console.log(res)
        const outputFilename = `CandidateList${Date.now()}.csv`;
        const link = document.createElement("a");
        link.href = res?.data?.filePath;
        link.setAttribute("download", outputFilename);
        document.body.appendChild(link);
        setIsLoading(false);
        link.click();
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  return (
    <div className="download-data--card--singleCard">
      {icon}
      <span>{title}</span>
      {btns.map((btn) => (
        <Button
          variant="outlined"
          color="success"
          onClick={() => {
            downloadExcel(btn?.apiKey, btn?.path);
          }}
        >
          {btn?.title}
        </Button>
      ))}
      {/* <Button variant="outlined" color="success" onClick={() => {
        downloadExcel(apiKey, path)
      }}>
        Download
      </Button>
     */}
    </div>
  );
}

export default DownloadData;
